'use strict';
const template = require('./tasks-details-filter.html');

module.exports = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('tasks/tasks-details-filter.html', template);
}



// WEBPACK FOOTER //
// ./src/js/tasks/filters/templates.js